<template>
    <div v-if="estimate" class="vuetify sub-account-details-content">
        <EstimateSummary :estimate="estimate" @pay-estimate="payEstimate()"
            @viewaccountinfo="accountInfoBottomSheet = true"></EstimateSummary>
        <div v-if="shouldShowEstimateDetailsLabel" class="estimate-details-label">
            <span class="vuetify label">{{ $translate('labels.estimateDetails') }}</span>
        </div>
        <SubAccountServicesCard :services="services"></SubAccountServicesCard>
        <AppointmentInfoCard :appointmentInfo="appointmentInfo" mode="estimate"></AppointmentInfoCard>
    </div>
    <base-bottom-sheet v-model="accountInfoBottomSheet" @close="closeBottomSheets">
        <card-header :title="$translate('labels.account')" icon="mdi-folder-plus-outline"
            class="sheet-card-header"></card-header>
        <account-info :accountInfo="accountInfo" data-testid="bill-summary-account-info-mobile"></account-info>
    </base-bottom-sheet>
</template>

<script>
import AppointmentInfoCard from './AppointmentInfoCard.vue';
import SubAccountServicesCard from './SubAccountServicesCard.vue';
import EstimateSummary from './EstimateSummary.vue';
import AccountInfo from './AccountInfo.vue';
import BaseBottomSheet from './BaseBottomSheet.vue';
import CardHeader from './CardHeader.vue';

export default {
    name: 'SubAccountDetailsContent',
    components: {
        AppointmentInfoCard,
        SubAccountServicesCard,
        EstimateSummary,
        AccountInfo,
        BaseBottomSheet,
        CardHeader
    },
    data() {
        return {
            accountInfoBottomSheet: false,
            provider: {},
            messageProviderData: {},
            estimate: {},
            appointmentInfo: {},
            accountInfo: {},
        }
    },
    computed: {
        currentEstimate() {
            return this.$store.getters.currentEstimate;
        },
        services() {
            return this.$store.getters.estimateServices;
        },
        currentUser() {
            return this.$store.getters.currentUser;
        },
        currentBill() {
            return this.$store.getters.currentBill;
        },
        closeBottomSheets() {
            this.accountInfoBottomSheet = false;
            if (this.emitter) {
                this.emitter.emit('responsive-provider-logo-left-column-persist-close-bottom-sheet');
            }
            return;
        },
        shouldShowEstimateDetailsLabel() {
            return (this.services && this.services.length);
        },
    },
    created() {
        this.$store.commit('setShowLoading', true);
        this.$nextTick(() => {
            if (this.shouldUseEstimateIdFromUrl(window.location.hash || window.location.pathname)) {
                this.loadEstimateFromUrl();
            } else if (this.currentEstimate) {
                this.loadCurrentEstimate(this.currentEstimate);
                this.setAccountInfo();
            } else {
                this.$router.push({ name: 'Home' });
            }
        });
    },
    methods: {
        shouldUseEstimateIdFromUrl(pathname) {
            if (pathname.includes("provider/") && pathname.includes("estimate/")) {
                return true;
            }
            return false;
        },
        // url format: #/dashboard/provider/ZZ5E3AD0/estimate/97741078
        _getEstimateIdFromRoute(pathname) {
            return this.$route.params.estimateId ?? null;
        },
        _getProviderIdFromRoute(pathname) {
            return this.$route.params.providerId ?? null;
        },
        _getEstimateFromProvider(provider, estimateId) {
            let estimate;
            let foundAccount;
            provider.accounts.forEach(function (account) {
                account.estimates.forEach(function (e) {
                    if (e.id == estimateId) {
                        estimate = e;
                        foundAccount = account;
                    }
                })
            });
            if (foundAccount && estimate) {
                this.accountInfo = {
                    patientName: estimate.patientName,
                    guarantorName: foundAccount.guarantorNames.join(', ') || '',
                    accountNumber: foundAccount.accountNumber || '',
                    primaryInsurance: foundAccount.primaryInsurance || ''
                };
            }
            return estimate;
        },
        loadEstimateFromUrl() {
            // we are on the estimate details page, look for ids in url to load vuex
            var pathname = window.location.hash || window.location.pathname;
            let estimateId = this._getEstimateIdFromRoute(pathname);
            let providerId = this._getProviderIdFromRoute(pathname);
            this.$store.dispatch('getProviderById', providerId).then((provider) => {
                this.provider = provider;
                this.messageProviderData = { "estimateId": estimateId, "reason": 11 };
                this.estimate = this._getEstimateFromProvider(provider, estimateId);
                this.estimate.providerDetails = provider;
                this.$store.commit('setCurrentEstimate', this.estimate);
                this.appointmentInfo = this.estimate.appointmentInfo;
                this.$store.commit('setShowLoading', false);
            }).catch((err) => {
                this.$store.commit('setShowLoading', false);
                this.$router.push({ name: 'ProvidersSummary' });
            });
        },
        loadCurrentEstimate(estimate) {
            // we are on verify estimate page, look for the ids in vuex
            if (!estimate) {
                this.$router.push({ name: 'ProvidersSummary' });
                this.$store.commit('setShowLoading', false);
            } else {
                this.estimate = estimate;
                this.$store.commit('setCurrentEstimate', estimate);
                this.provider = estimate.providerDetails;
                this.messageProviderData = { "estimateId": estimate.id, "reason": 11 };
                this.appointmentInfo = estimate.appointmentInfo;
                this.$store.commit('setShowLoading', false);
            }
        },
        payEstimate() {
            this.requireAuthedUserForLink('EstimatePaymentFlowAmountStep', {
                accountId: this.estimate.accountId,
                providerId: this.provider.id,
                estimateId: this.estimate.id,
            });
        },
        requireAuthedUserForLink(state, params) {
            const onAuthSuccess = () => {
                this.getUserAndLink(state, params);
            };
            this.emitter.emit('require-authed-user', { params: {}, successCallback: onAuthSuccess });
        },
        getUserAndLink(state, params) {
            this.$store.dispatch('linkEstimate', this.estimate).then(() => {
                if (this.estimate.providerDetails.requiresRedirectToBranded) {
                    this.emitter.emit('redirect:tab', {
                        provider: this.provider,
                        context: {
                            stateGo: {
                                to: state,
                                toParams: params
                            }
                        }
                    });
                } else {
                    this.$router.push({
                        name: state,
                        params: params,
                    });
                }
            }).catch((message) => {
                console.error(message);
            });
        },
        setAccountInfo() {
            this.accountInfo.guarantorName = this.estimate?.guarantorDetails?.name;
            this.accountInfo.patientName = this.estimate?.patientName;
            this.accountInfo.accountNumber = this.estimate?.accountNumber;
        },
        composeMessage() {
            const authParams = {};
            const onAuthSuccess = () => {
                this.$store.dispatch('linkEstimate', this.estimate).then(() => {
                    if (this.estimate.providerDetails.requiresRedirectToBranded) {
                        this.emitter.emit('redirect:tab', {
                            provider: this.provider,
                            context: {
                                stateGo: {
                                    to: 'SubAccountDetails',
                                    toParams: {
                                        id: this.provider.id,
                                        estimateId: this.estimate.subAccount.id,
                                    }
                                },
                                emit: ['message:compose', this.messageProviderData],
                            },
                        });
                    } else {
                        this.emitter.emit('message:compose', this.messageProviderData);
                    }
                }).catch((message) => {
                    console.error(message);
                });
            };
            this.emitter.emit('require-authed-user', { params: authParams, successCallback: onAuthSuccess });
        },
    }
}

</script>
<style lang="scss">
@import './../styles/variables.scss';

.estimate-details-label {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1.4rem 0 0 0;

    span.vuetify.label {
        color: $global-color-font-new;
        font-size: 2.4rem;
        width: 100%;
        margin-left: 1.4rem;
        margin-bottom: 1.4rem;

        @include wider-than-tablet {
            margin-left: 0.9rem;
            font-size: 2.4rem;
            margin-bottom: 0.9rem;
        }

        &:hover::before,
        &:active::before {
            opacity: 0;
        }
    }
}
</style>